import { PermissionLevel, UserStatus, ZoomLevel } from "@/modules/common/types";
import { muiTheme } from "@/styles/theme";

export const sale_categories = [
  { value: "Primary", label: "Primary" },
  { value: "Resale Buyer", label: "Resale Buyer" },
  { value: "Resale Seller", label: "Resale Seller" },
  { value: "Nawy Now", label: "Nawy Now" },
  { value: "Commercial Sale", label: "Commercial Sale" },
  { value: "Commercial Leasing", label: "Commercial Leasing" },
  { value: "Developer Commercial Sale", label: "Developer Commercial Sale" },
  { value: "Developer Resale", label: "Developer Resale" },
  { value: "Nawy Now Refinance", label: "Nawy Now Refinance" },
  { value: "Unlocked-Now", label: "Unlocked-Now" },
];

export enum SaleCategory {
  PRIMARY = "Primary",
  RESALE_BUYER = "Resale Buyer",
  RESALE_SELLER = "Resale Seller",
  NAYW_NOW = "Nawy Now",
  COMMERCIAL_SALE = "Commercial Sale",
  COMMERCIAL_LEASING = "Commercial Leasing",
  DEVELOPER_COMMERCIAL_SALE = "Developer Commercial Sale",
  DEVELOPER_RESALE = "Developer Resale",
  NAYW_NOW_REFINANCE = "Nawy Now Refinance",
  UNLOCKED_NOW = "Unlocked-Now",
}

export const sales_types = [
  { id: 1, sale_type: "Contracted" },
  { id: 2, sale_type: "Reserved" },
  { id: 3, sale_type: "Blocked" },
  { id: 4, sale_type: "EOI" },
  { id: 5, sale_type: "Potential" },
];

export const nawy_offices = [
  { value: "0", label: "47 office" },
  { value: "1", label: "first settlement office" },
  { value: "2", label: "october office" },
  { value: "3", label: "Other" },
];

export const client_objectives = [
  { value: "1", label: "investor" },
  { value: "0", label: "end user" },
];

// export const commonSkeletonStyles = {
//   flex: "2",
//   whiteSpace: "nowrap",
//   overflow: "hidden",
//   textOverflow: "ellipsis",
// };

export const zoomMarginTopMap: Record<ZoomLevel, number> = {
  120: 53.5,
  110: 58,
  100: 64,
  90: 71,
  80: 80,
  70: 91.5,
  60: 107,
  50: 128,
  40: 160,
  30: 214,
};

export const newToOldPathsMap = new Map([
  ["/next-actions", "/nextActions"],
  ["/agents-tree", "/agentsTree"],
  ["/sales-commissions", "/sales-agents-commissions"],
  ["/sales", "/sales"],
  ["/listing-dashboard", "/listing-dashboard"],
  ["/nawy-calculator", "/calculator"],
  ["/comments-search", "/search-by-comments"],
  ["/settings/facebook-rules", "/settings/facebookRules"],
  ["/settings/pools", "/settings/pools"],
  ["/settings/auto-assignment-pools", "/settings/autoAssignmentPools"],
  ["/settings/payment-plans", "/settings/paymentPlans"],
  ["/settings/configurations", "/settings/configurations"],
  ["/settings/lead-icons", "/lead-icons"],
  ["/settings/categories", "/settings/categories"],
  ["/settings/funnels", "/settings/funnels"],
  ["/agents-activity", "/agents"],
  ["/agents-targets", "/agents"],
  ["/auto-delegation-weights", "/agents"],
  ["/settings/statuses", "/settings/statuses"],
  ["/commissions", "/commissions"],
  ["/dashboards", "/dashboards"],
  ["/marketing-spend", "/marketing-spend"],
  ["/nawy-inventory", "/nawy-inventory"],
  ["/statuses-glossary", "/statuses-glossary"],
  ["/league", "/league"],
  ["/settings/users", "/settings/users"],
]);

export const queriesToInvalidate = [
  ["leads"],
  ["agentsTargets"],
  ["getUsersWithTargets"],
  ["getStatusFunnelsV2"],
  ["leadTypesV2"],
  ["getInitialNodes"],
  ["getStatusesUsers"],
  ["getStatusCategoriesV2"],
  ["getStatusesV2"],
  ["getLeadTypes"],
  ["getInitialNodes"],
  ["getPools"],
  ["getActivityUsers"],
  ["agents-activity-search"],
  ["getUserLocations"],
  ["getUsers"],
  ["getLocations"],
  ["getAutoAssignmentWeights"],
  ["organizationTarget"],
  ["dailyOperations"],
  ["configurations"],
  ["directReports"],
  ["marketingSpendUrl"],
  ["currentUserUrl"],
];

export enum FilterType {
  ORGANIZATION = "organization",
  ACCOUNT_MANAGER = "account-manager",
  NONE = 0,
}
export const LIST_TYPES = [
  { value: "OLD_LEADS", label: "Old Leads" },
  { value: "PERSONAL", label: "Personal" },
];

export const LIST_CATEGORIES = [
  { value: "GENERAL", label: "General" },
  { value: "REAL ESTATE", label: "Real Estate" },
];

export const ORGANIZATION_UID = "ee911f5e-5748-42c4-adfc-3e67c1430140";

export const userStatusOptions = [
  { value: UserStatus.Active, label: "active" },
  { value: UserStatus.Fresh, label: "fresh" },
  { value: UserStatus.Blocked, label: "blocked" },
  { value: UserStatus.Banned, label: "banned" },
];

export const defaultUserStatuses = [
  UserStatus.Active,
  UserStatus.Fresh,
  UserStatus.Blocked,
];

export const ORGANIZATION_TIER_TYPES = {
  nawy: "nawy",
  taskeen: "taskeen",
  partner: "partner",
};

/**
 * Operating base of an organization's tier, which decides whose inventory (areas, developers,
 * compounds) the CRM shows. Values mirror the ones UMS publishes, so what comes back from
 * my-organization can be forwarded to the CRM API as-is.
 */
export enum Country {
  EGYPT = "egypt",
  UAE = "uae",
  SAUDI_ARABIA = "saudi_arabia",
  IRAQ = "iraq",
}

export enum Pages {
  HOME = "home",
  SALES = "sales",
  DASHBOARDS = "dashboards",
  NEXT_ACTIONS = "next-actions",
}

export const permissionLevelMap = new Map([
  [PermissionLevel.READ, 1],
  [PermissionLevel.WRITE, 2],
  [PermissionLevel.ALL, 3],
]);

export const autocompleteStyles = {
  backgroundColor: muiTheme.colorSchemes.light.palette.primary[200],
  color: muiTheme.colorSchemes.light.palette.primary[500],
  height: "22px",
};

export const owestBannerURL = "https://my.orascomdh.com/partners/login";

// Subdepartments that require pools when under Sales department
export const SALES_SUBDEPARTMENTS_REQUIRING_POOLS = [
  "Primary Nawy",
  "Resale",
  "Nawy Now",
  "Nawy Unlocked",
] as const;

export const SALES_DEPARTMENT_NAME = "Sales";

export {
  FeatureFlagsKeys,
  type FeatureFlagKey,
} from "@/modules/common/context/feature-flags.constants";
